import { observer } from 'mobx-react';
import React, { Fragment, useEffect, useRef } from 'react';
import { ReleaseNotesVM } from './ReleaseNotesVM';
import './ReleaseNotes.scss';
import { formatDateShort } from 'cd-eft/utils/formatDate';
import { ReleaseNoteDto } from 'cd-eft/_codegen_/openapi-generator/eft-prjadmin';

interface IReleaseNoteProps {
  date?: string;
  version?: string;
  title?: string;
  index: number;
}
interface IReleaseNotesListProps {
  notes?: ReleaseNoteDto[];
}

const SingleNote = (props: IReleaseNoteProps) => {
  const version: string = props.version!;
  const date: string = formatDateShort('' + props.date!);
  const title: string = props.title!;

  return (
    <div className="row pl-2" tabIndex={0}>
      <div className="note-item justify-content-center col-def" id={`version${props.index}`}>
        {version}
      </div>
      <div className="note-item justify-content-center col-def-2" id={`date${props.index}`}>
        {date}
      </div>
      <div className="note-item col" id={`title${props.index}`}>
        <a href="/about#release_notes">{title}</a>
      </div>
    </div>
  );
};

const ReleaseNotesComponent = () => {
  const vm = useRef(new ReleaseNotesVM()).current;
  useEffect(() => {
    vm.getReleaseNotes();
  }, []);
  return (
    <Fragment>
      <div className="notes-box mb-2  usa-card__container">
        <h3 className="usa-card__header" aria-label="release notes" tabIndex={0}>
          <strong>Release Notes</strong>
        </h3>
        <div className="update-table col usa-card__body">
          {vm.releaseNotes
            ? vm.releaseNotes?.map((note, index) => (
              <SingleNote
                key={index}
                date={note.releaseDate}
                version={note.releaseVersion}
                title={note.releaseTitle}
                index={index}
              />
            ))
            : null}
        </div>
      </div>
    </Fragment>
  );
};

export const ReleaseNotesList = observer(ReleaseNotesComponent);
